import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './store/store';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./utils/auth/msalConfig";

global.Buffer = global.Buffer || require('buffer').Buffer;

export const msalInstance = new PublicClientApplication(msalConfig);
const root = ReactDOM.createRoot(document.getElementById('root'));

async function renderApp() {
  // Required for MSAL v3+ to avoid "uninitialized_public_client_application" error
  await msalInstance.initialize();
  
  // Handle redirect promise - this is crucial for login to work
  await msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
      }
    })
    .catch((error) => {
    });
  
  root.render(
    <Provider store={store}>
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </MsalProvider>
      </React.StrictMode>
    </Provider>
  );
}
renderApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();